import { ButtonLink } from "@/components/common";
import { useSeo } from "@/lib/seo";

export default function NotFound({ message = "This page doesn't exist — yet." }) {
  useSeo({ title: "Page not found — Lutazzi", description: "The page you're looking for doesn't exist." });
  return (
    <section className="relative flex min-h-[90vh] items-center overflow-hidden pt-24" data-testid="not-found-page">
      <span className="pointer-events-none absolute -right-[4vw] bottom-0 select-none font-display text-[38vw] leading-[0.75] text-gold/10" aria-hidden>404</span>
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden />
      <div className="container-x relative">
        <p className="label-mono"><span className="text-gold">404</span> — Lost in the grid</p>
        <h1 className="mt-6 max-w-3xl font-display text-5xl leading-[0.95] sm:text-6xl lg:text-8xl">{message}</h1>
        <p className="mt-6 max-w-md text-silver">But if you were looking for something that doesn't exist yet, you're in the right studio.</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <ButtonLink to="/" testId="not-found-home-link">Back home</ButtonLink>
          <ButtonLink to="/work" variant="secondary" testId="not-found-work-link">Browse the work</ButtonLink>
          <ButtonLink to="/contact?type=other" variant="ghost" testId="not-found-contact-link">Start something new</ButtonLink>
        </div>
      </div>
    </section>
  );
}
